export default "__VITE_ASSET__57175b99__"